module.exports = __webpack_public_path__ + "img/zhileng.acc4e19b.png";